export interface RacerIdentity {
  id: string
  name: string
  accent: string
}

export const RACER_IDENTITIES: readonly RacerIdentity[] = [
  { id: 'player', name: 'YOU // TRIDE', accent: '#4df4ff' },
  { id: 'rival-1', name: 'NYX', accent: '#ff3864' },
  { id: 'rival-2', name: 'VANTA', accent: '#7c5cff' },
  { id: 'rival-3', name: 'KITE', accent: '#41e9ff' },
  { id: 'rival-4', name: 'ROOK', accent: '#ff9d2e' },
  { id: 'rival-5', name: 'GHOST', accent: '#b8ff5a' },
]

export function getRacerIdentity(id: string): RacerIdentity {
  return RACER_IDENTITIES.find((racer) => racer.id === id) ?? { id, name: id.toUpperCase(), accent: '#f7fbff' }
}
